'use client';
import React from 'react';
import { Skeleton, SkeletonText } from '@/components/primitives/skeleton';
import styles from './styles.module.scss';
import useSize from '@/hooks/use-size';

const SkeletonFeedItem = () => {
  const { width } = useSize();
  const imageSize = width;

  return (
    <div className={styles.feedContainer}>
      {/* Skeleton for feed image */}
      <div
        className={styles.imageContainer}
        style={{
          width: '100%',
          minWidth: imageSize,
          minHeight: imageSize,
          alignSelf: 'center',
          height: imageSize,
          aspectRatio: 1,
        }}
      >
        <Skeleton className={styles.imageSkeleton} />
      </div>

      {/* Skeleton for profile section */}
      <div className={styles.profileSection}>
        <div className={styles.profileLink}>
          <Skeleton className={styles.avatarSkeleton} variant="circular" />
          <div className={styles.profileInfo}>
            <SkeletonText className={styles.profileNameSkeleton} />
            <SkeletonText className={styles.profileUsernameSkeleton} />
          </div>
        </div>
        <div className={styles.profileActions}>
          <Skeleton className={styles.followButtonSkeleton} />
          <Skeleton className={styles.moreButtonSkeleton} />
        </div>
      </div>

      {/* Skeleton for content section */}
      <div className={styles.contentSection}>
        <div className={styles.captionContainer}>
          <SkeletonText className={styles.captionTextSkeleton} />
          <SkeletonText className={`${styles.captionTextSkeleton} ${styles.partial}`} />
        </div>

        {/* Skeleton for links section */}
        <div className={styles.linksSection}>
          <SkeletonText className={styles.linksTitleSkeleton} />
          <div className={styles.linksContainer}>
            <Skeleton className={styles.linkItemSkeleton} />
            <Skeleton className={styles.linkItemSkeleton} />
          </div>
        </div>

        <div className={styles.contentFooter}>
          <SkeletonText className={styles.timestampSkeleton} />
          <div className={styles.actionButtons}>
            <div className={styles.actionButtonGroup}>
              <Skeleton className={styles.actionButtonSkeleton} />
            </div>
            <div className={styles.actionButtonGroup}>
              <Skeleton className={styles.actionButtonSkeleton} />
              <SkeletonText className={styles.actionCountSkeleton} />
            </div>
            <div className={styles.actionButtonGroup}>
              <Skeleton className={styles.actionButtonSkeleton} />
              <SkeletonText className={styles.actionCountSkeleton} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonFeedItem;
